import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { ApiTravelMemberHelperService } from './travel-member-helper.service';
import { tap } from 'rxjs/operators';
import { ApiTravelMemberAuthService } from './travel-member-auth.service';
import { ApiAuthService } from '../auth';

@Injectable({ providedIn: 'root' })
export class ApiTravelMemberService {
  constructor(
    public hpr: ApiTravelMemberHelperService,
    private _api: ApiService,
    private _apiAuth: ApiAuthService,
    private _auth: ApiTravelMemberAuthService,
  ) {}

  get(id: number | string) {
    return this._api.get('travel-member/get/id/' + id);
  }

  list(data: any = {}) {
    return this._api.post('travel-member/list', data);
  }

  create(data: any) {
    return this._api.post('travel-member/create', data);
  }

  update(data: any) {
    return this._api.post('travel-member/update', data).pipe(
      tap((result) => {
        if (result.data.id == this._auth.travelMemberId) {
          this._auth.setTravelMember(result.data);
        }
      }),
    );
  }

  updateStatus(data: any) {
    return this._api.post('travel-member/update', data);
  }

  upload(data: any) {
    return this._api.upload('travel-member/upload', data);
  }

  remove(id: number) {
    return this._api.post('travel-member/remove/id/' + id);
  }

  register(data: any) {
    return this._api
      .post('travel-member/register', data)
      .pipe(tap((result) => this._apiAuth.setUser(result.meta.user)));
  }
}
